export const correctArticleNumberLength = (
  item_no: number | string
): string => {
  const articleNumberStr = item_no.toString();
  return articleNumberStr.padStart(8, "0");
};
